import { useState, useEffect, useRef } from 'react';
import { useForm } from "react-hook-form";

import InfoCard from '../widgets/InfoCard';
import { appConfig } from '../../services/config';
import * as services from '../../services/services';
import * as utils from '../../services/utils';

import '../Main.css';

function ClientCredInfo(props) {  

  /* Form Validation */
	
  const {
    register,
    formState: { errors },
    trigger,
    reset
  } = useForm();

  /* Data */

  props.connectData.getData = getData;
  props.connectData.handleCloseInfo = handleCloseInfo;
  props.connectData.trigger = trigger;

  const handleDisplayCmdData = props.connectData.handleDisplayCmdData;

  const defaultData = {
    titleLink: appConfig.iuaITI71Url,
    isPopulateMd: false,
    wellKnownUri: appConfig.wellKnownUri,
    tokenUri: appConfig.tokenUri,
    clientId: appConfig.serviceClientId,
    clientSecret: appConfig.serviceClientSecret, 
    // scopes
    scopeCafex1: false,
    scopeCafex2: false,
    scopeCafex3: false,
    scopeIti65: false,
    scopeIti66: false,
    scopeIti67: false,
    scopeIti68: false,
    scopeOther: appConfig.scopes
  };   

  const isPopulateMdRef = useRef();
  const wellKnownUriRef = useRef();
  const tokenUriRef = useRef();
  const clientIdRef = useRef();
  const clientSecretRef = useRef();  
  // scopes
  const scopeCafex1Ref = useRef();
  const scopeCafex2Ref = useRef();
  const scopeCafex3Ref = useRef();
  const scopeIti65Ref = useRef();
  const scopeIti66Ref = useRef();
  const scopeIti67Ref = useRef();
  const scopeIti68Ref = useRef();
  const scopeOtherRef = useRef();

  function getData() {
    let scopeOther = scopeOtherRef.current?.value;
    // normalize space
    scopeOther = scopeOther.trim();
    scopeOther = scopeOther.replace(',',' ');
    scopeOther = scopeOther.replace(/^\s*|\s(?=\s)|\s*$/g, "");

    let scopes = '';
    scopes = scopeCafex1Ref.current?.checked ? scopes.concat(' ').concat(scopeCafex1Ref.current?.value) : scopes;
    scopes = scopeCafex2Ref.current?.checked ? scopes.concat(' ').concat(scopeCafex2Ref.current?.value) : scopes;
    scopes = scopeCafex3Ref.current?.checked ? scopes.concat(' ').concat(scopeCafex3Ref.current?.value) : scopes;
    scopes = scopeIti65Ref.current?.checked ? scopes.concat(' ').concat(scopeIti65Ref.current?.value) : scopes;
    scopes = scopeIti66Ref.current?.checked ? scopes.concat(' ').concat(scopeIti66Ref.current?.value) : scopes;
    scopes = scopeIti67Ref.current?.checked ? scopes.concat(' ').concat(scopeIti67Ref.current?.value) : scopes;
    scopes = scopeIti68Ref.current?.checked ? scopes.concat(' ').concat(scopeIti68Ref.current?.value) : scopes;
    scopes = scopeOther ? scopes.concat(' ').concat(scopeOther) : scopes;
    scopes = scopes.trim();

    const clientId = clientIdRef.current?.value;
    const clientSecret = clientSecretRef.current?.value;
    let base64Credentials = utils.getBase64Credentials(clientId, clientSecret);

    return  {
      tokenUri: tokenUriRef.current?.value?.trim(),      
      clientId: clientId,
      base64Credentials: base64Credentials,
      scopes: scopes
    }
  }

  /* Populate MD */
  
  const [tokenUri, setTokenUri] = useState(defaultData.tokenUri);
  const [populateMdChecked, setPopulateMdChecked] = useState(defaultData.isPopulateMd);

  useEffect(() => {
    handleDisplayCmdData();
    reset(
      {tokenUri: tokenUri}, 
      {keepErrors: true, 
        keepDirty: true});
  }, [tokenUri]);

  function handlePopulateMdCheck() {
    const populateMdChecked = isPopulateMdRef.current?.checked;
    setPopulateMdChecked(populateMdChecked);
  }

  function handlePopulateMd(event) {
    event.preventDefault(); 
    const wellKnownUri = wellKnownUriRef.current?.value;
    services
      .getMD(wellKnownUri)
      .then(data => {
        setTokenUri(data.token_endpoint);
      })    
      .then(() => {
        setTimeout(() => trigger('tokenUri'));
      });
  }

  function handleChangeTokenUri() {
    setTokenUri(tokenUriRef.current?.value);
  } 

   /* Client Secret */

  const [clientSecret, setClientSecret] = useState(defaultData.clientSecret);

  useEffect(() => {
    handleDisplayCmdData();
    reset(
      {clientSecret: clientSecret}, 
      {keepErrors: true, 
        keepDirty: true});
  }, [clientSecret]);

  function handleChangeClientSecret() {
    setClientSecret(clientSecretRef.current?.value);
  }

  /* Info Card */

  const [infoCardIsOpen, setInfoCardIsOpen] = useState(false); 
  const [clientCredFlowCardIsOpen, setClientCredFlowCardIsOpen] = useState(false); 
  const [wellKnownUriCardIsOpen, setWellKnownUriCardIsOpen] = useState(false); 
  const [tokenUriCardIsOpen, setTokenUriCardIsOpen] = useState(false); 
  const [clientIdCardIsOpen, setClientIdCardIsOpen] = useState(false); 
  const [clientSecretCardIsOpen, setClientSecretCardIsOpen] = useState(false); 
  const [scopesCardIsOpen, setScopesCardIsOpen] = useState(false); 

  function handleCloseInfo() {
    setInfoCardIsOpen(false);
    setClientCredFlowCardIsOpen(false);
    setWellKnownUriCardIsOpen(false);
    setTokenUriCardIsOpen(false);
    setClientIdCardIsOpen(false);
    setClientSecretCardIsOpen(false);
    setScopesCardIsOpen(false);
  }

  const [isInfoHover, setIsInfoHover] = useState(false);
  const [isClientCredFlowHover, setIsClientCredFlowHover] = useState(false);
  const [isWellKnownUriHover, setIsWellKnownUriHover] = useState(false);
  const [isTokenUriHover, setIsTokenUriHover] = useState(false);
  const [isClientIdHover, setIsClientIdHover] = useState(false);
  const [isClientSecretHover, setIsClientSecretHover] = useState(false);
  const [isScopesHover, setIsScopesHover] = useState(false);

  const isInfoHoverRef = useRef(isInfoHover);
  const isClientCredFlowHoverRef = useRef(isClientCredFlowHover);
  const isWellKnownUriHoverRef = useRef(isWellKnownUriHover);
  const isTokenUriHoverRef = useRef(isTokenUriHover);
  const isClientIdHoverRef = useRef(isClientIdHover);
  const isClientSecretHoverRef = useRef(isClientSecretHover);
  const isScopesHoverRef = useRef(isScopesHover);

  isInfoHoverRef.current = isInfoHover;
  isClientCredFlowHoverRef.current = isClientCredFlowHover;
  isWellKnownUriHoverRef.current = isWellKnownUriHover;
  isTokenUriHoverRef.current = isTokenUriHover;
  isClientIdHoverRef.current = isClientIdHover;
  isClientSecretHoverRef.current = isClientSecretHover;
  isScopesHoverRef.current = isScopesHover;

  useEffect(() => {
    isInfoHoverRef.current && setInfoCardIsOpen(true);
    const timer = setTimeout(() => {
      isClientCredFlowHoverRef.current && setClientCredFlowCardIsOpen(true);
      isWellKnownUriHoverRef.current && setWellKnownUriCardIsOpen(true);
      isTokenUriHoverRef.current && setTokenUriCardIsOpen(true);
      isClientIdHoverRef.current && setClientIdCardIsOpen(true);
      isClientSecretHoverRef.current && setClientSecretCardIsOpen(true);
      isScopesHoverRef.current && setScopesCardIsOpen(true);
    }, 800);
    return () => clearTimeout(timer);
  }, [isInfoHover, isClientCredFlowHover, isWellKnownUriHover, 
      isTokenUriHover, isClientIdHover, isClientSecretHover, isScopesHover]);

  return (
  <div className="row">
    <div className="col-7">

      <div className="md-form spc-pb-0">

        {/* Auth MD */}

        <div>
          {/* Populate Md */}
          <div className="form-group">
            <input type="checkbox" className="spc-ml-0" id="populateMd" value="populateMd" 
              defaultChecked={defaultData.isPopulateMd} 
              onChange={() => {                
                handlePopulateMdCheck();
              }} 
              ref={isPopulateMdRef}/>
            <label htmlFor="populateMd" className="select-label">Populate Token endpoint from server metadata</label>
          </div>

          <div className="pt-2">              
            {populateMdChecked && <div>
              {/* well-known URI */}        
              <div className="md-form spc-pb-8">
                <label htmlFor="wellKnownUri" className="active" 
                  onMouseEnter={() => setIsWellKnownUriHover(true)}
                  onMouseOut={() => {setIsWellKnownUriHover(false); handleCloseInfo()}}        
                  > Well Known URI 
                  <span className="required-text"> (required) </span></label>
                <input type="text" id="wellKnownUri" className="form-control" spellCheck="false"
                  defaultValue={defaultData.wellKnownUri}     
                  {...register("wellKnownUri", {        
                    required: "Well Known URI is required",    
                    pattern: {
                      value: /^http(s)?:\/\/[a-zA-Z0-9_+-]+(:[0-9]+)?(\/)?[-a-zA-Z0-9()@:%_+.~#?&//=]+/i,
                      message: "Well Known URL is invalid",
                    },
                    onBlur: () => trigger("wellKnownUri")
                  })}
                  ref={e => {
                    const { ref } = register('wellKnownUri');
                    ref(e);
                    wellKnownUriRef.current = e;
                  }}
                  onChange={handleDisplayCmdData}
                />
                {errors.wellKnownUri && (
                  <div className="validation-msg error">{errors.wellKnownUri.message}</div>
                )}                  
              </div>
              <div className="md-form spc-pb-20 spc-ml-10">
                <button className="btn-sm btn-outline-danger" onClick={handlePopulateMd}>Populate</button>
              </div>                
            </div>}

          </div>          
        </div>
      </div>
      
      <div className="row">
        <div className="spc-ml-15">
        <h5 className="main-title"><span 
            onMouseEnter={() => setIsClientCredFlowHover(true)}
            onMouseOut={() => {setIsClientCredFlowHover(false); handleCloseInfo()}} 
            > Client Credentials Flow </span> 
              (<a className='aLink' href={defaultData.titleLink} target="_blank" rel="noreferrer">
                IUA ITI-71 Get Access Token</a>)</h5>
        </div>
      </div>

      {/* Token URI */}
      
      <div className="md-form">
        <label htmlFor="tokenUri" className="active" 
          onMouseEnter={() => setIsTokenUriHover(true)}
          onMouseOut={() => {setIsTokenUriHover(false); handleCloseInfo()}}
          > Token URI 
          <span className="required-text"> (required) </span></label>
        <input type="text" id="tokenUri" className="form-control" spellCheck="false"
          value={tokenUri}            
          {...register("tokenUri", {        
            required: "Token URI is required",    
            pattern: {
              value: /^http(s)?:\/\/[a-zA-Z0-9_+-]+(:[0-9]+)?(\/)?[-a-zA-Z0-9()@:%_+.~#?&//=]+/i,
              message: "Token URL is invalid",
            },
            onBlur: () => trigger("tokenUri")
          })}
          ref={e => {
            const { ref } = register('tokenUri');
            ref(e);
            tokenUriRef.current = e;
          }}
          onChange={handleChangeTokenUri}
        />
        {errors.tokenUri && (
          <div className="validation-msg error">{errors.tokenUri.message}</div>
        )}
      </div>
 
      {/* Client ID */}

      <div className="md-form">
        <label htmlFor="clientId" className="active" 
          onMouseEnter={() => setIsClientIdHover(true)}
          onMouseOut={() => {setIsClientIdHover(false); handleCloseInfo()}}
          > Client ID 
          <span className="required-text"> (required) </span></label>
        <input type="text" id="clientId"  className="form-control" spellCheck="false"
          defaultValue={defaultData.clientId}           
          {...register("clientId", { required: "Client ID is required", onBlur: () => trigger("clientId") })}
          ref={e => {
            const { ref } = register('clientId');
            ref(e);
            clientIdRef.current = e;
          }}
          onChange={() => {handleDisplayCmdData(); setClientSecret('')}}
        />
        {errors.clientId && (
          <div className="validation-msg error">{errors.clientId.message}</div>
        )}
      </div>

      <div className="md-form spc-pb-0">

        {/* Client Secret */}

        <div className="md-form">
          <label htmlFor="clientSecret" className="active" 
            onMouseEnter={() => setIsClientSecretHover(true)}
            onMouseOut={() => {setIsClientSecretHover(false); handleCloseInfo()}}  
            > Client Secret 
            <span className="required-text"> (required) </span></label>
          <input type="password" id="clientSecret" className="form-control" spellCheck="false"
            value={clientSecret}
            {...register("clientSecret", { required: "Client Secret is required", 
                  onBlur: () => trigger("clientSecret") })}
            ref={e => {
              const { ref } = register('clientSecret');
              ref(e);
              clientSecretRef.current = e;
            }}
            onChange={() => {handleDisplayCmdData(); handleChangeClientSecret()}}
          />
          {errors.clientSecret && (
            <div className="validation-msg error">{errors.clientSecret.message}</div>
          )}          

        </div>
      </div>

      <div className="md-form spc-pb-15">
         
        {/* Scopes */}
 
        <label className="form-group-label active" 
          onMouseEnter={() => setIsScopesHover(true)}
          onMouseOut={() => {setIsScopesHover(false); handleCloseInfo()}} 
          > Scopes </label>

        <div className="scope-grid">          
          <div className="form-group">            
            <label className="select-label label-sm">CA:FeX</label>
          </div>
          <div className="form-group">
            <input type="checkbox" value="CAFEX-1" defaultChecked={defaultData.scopeCafex1} onChange={handleDisplayCmdData} ref={scopeCafex1Ref}/>
            <label className="select-label">CAFEX-1</label>
          </div>
          <div className="form-group">
            <input type="checkbox" value="CAFEX-2" defaultChecked={defaultData.scopeCafex2} onChange={handleDisplayCmdData} ref={scopeCafex2Ref}/>
            <label className="select-label">CAFEX-2</label>
          </div>
          <div className="form-group">
            <input type="checkbox" value="CAFEX-3" defaultChecked={defaultData.scopeCafex3} onChange={handleDisplayCmdData} ref={scopeCafex3Ref}/>
            <label className="select-label">CAFEX-3</label>
          </div> 
          <div></div>

          <div className="form-group">
            <label className="select-label label-sm">MHD</label>
          </div>
          <div className="form-group">
            <input type="checkbox" value="ITI-65" defaultChecked={defaultData.scopeIti65} onChange={handleDisplayCmdData} ref={scopeIti65Ref}/>
            <label className="select-label">ITI-65</label>
          </div>
          <div className="form-group">
            <input type="checkbox" value="ITI-66" defaultChecked={defaultData.scopeIti66} onChange={handleDisplayCmdData} ref={scopeIti66Ref}/>
            <label className="select-label">ITI-66</label>
          </div>
          <div className="form-group">
            <input type="checkbox" value="ITI-67" defaultChecked={defaultData.scopeIti67} onChange={handleDisplayCmdData} ref={scopeIti67Ref}/>
            <label className="select-label">ITI-67</label>
          </div>          
          <div className="form-group">
            <input type="checkbox" value="ITI-68" defaultChecked={defaultData.scopeIti68} onChange={handleDisplayCmdData} ref={scopeIti68Ref}/>
            <label className="select-label">ITI-68</label>
          </div>
          
        </div>

        <div className="scope-grid-other">          
          <div className="form-group">            
            <label className="select-label label-sm">Other</label>
          </div>
          <div>
            <input type="text" id="scopes" className="scope-input-other" spellCheck="false"
              defaultValue={defaultData.scopeOther} onChange={handleDisplayCmdData} ref={scopeOtherRef}/>
          </div>
        </div>
      </div>

    </div>

    <div className="col-5">
      <div className="algn-right"><i className="fa fa-info-circle sm" 
        onMouseEnter={() => setIsInfoHover(true)}
        onMouseOut={() => {setIsInfoHover(false); handleCloseInfo()}}        
        ></i></div>
      <div>
        {infoCardIsOpen && <InfoCard id="info"></InfoCard>}
        {clientCredFlowCardIsOpen && <InfoCard id="clientCredFlow"></InfoCard>}
        {wellKnownUriCardIsOpen && <InfoCard id="wellKnownUri"></InfoCard>}
        {tokenUriCardIsOpen && <InfoCard id="tokenUri"></InfoCard>}  
        {clientIdCardIsOpen && <InfoCard id="clientId"></InfoCard>}
        {clientSecretCardIsOpen && <InfoCard id="clientSecret"></InfoCard>}
        {scopesCardIsOpen && <InfoCard id="scopes"></InfoCard>}
      </div>
    </div>
    
  </div>
  );
}

export default ClientCredInfo;
